import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon, LockIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
export function PricingSection() {
  const checkoutUrl = 'https://checkout.guiadigital360.online/cart/43928145002565:1';
  return <section id="compra" className="py-24 px-4 bg-brand-light scroll-mt-10" data-id="element-225">
      <div className="max-w-6xl mx-auto" data-id="element-226">
        <div className="text-center mb-16" data-id="element-227">
          <h2 className="text-5xl font-black text-brand-dark mb-4" data-id="element-228">
            Elegí tu MegaPack:
          </h2>
          <p className="text-2xl font-bold text-brand-blue" data-id="element-229">
            Todas las opciones incluyen los 6 bonos estratégicos
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 items-center mb-16" data-id="element-230">
          {/* Card 1: Iniciación */}
          <div className="bg-white rounded-3xl p-8 shadow-lg border border-gray-200 flex flex-col h-full" data-id="element-231">
            <div className="text-5xl mb-4" data-id="element-232">📘</div>
            <h3 className="text-2xl font-black text-brand-dark mb-2" data-id="element-233">
              PACK INICIACIÓN
            </h3>
            <p className="text-xl font-bold text-gray-700 mb-2" data-id="element-234">
              Cuadernillos 1 y 2
            </p>
            <p className="text-gray-600 mb-1" data-id="element-235">1° y 2° año + bonos</p>
            <p className="text-gray-600 mb-8" data-id="element-236">120 páginas listas</p>

            <div className="mt-auto" data-id="element-237">
              <div className="text-gray-400 text-xl line-through font-bold mb-1" data-id="element-238">
                $29.900
              </div>
              <div className="text-4xl font-black text-brand-orange mb-8" data-id="element-239">
                $19.990 ARS
              </div>
              <CTAButton text="→ QUIERO PACK INICIACIÓN" href={checkoutUrl} isLink={true} className="text-lg py-3" data-id="element-240" />
            </div>
          </div>

          {/* Card 2: Completo (Highlighted) */}
          <div className="bg-white rounded-3xl p-8 shadow-2xl border-4 border-brand-orange relative transform lg:scale-105 z-10 flex flex-col h-full" data-id="element-241">
            <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-brand-orange text-white font-black px-6 py-2 rounded-full text-sm tracking-widest shadow-md whitespace-nowrap" data-id="element-242">
              ⭐ MÁS ELEGIDO
            </div>

            <div className="text-5xl mb-4 text-center mt-4" data-id="element-243">🏆</div>
            <h3 className="text-3xl font-black text-brand-dark mb-2 text-center" data-id="element-244">
              PACK COMPLETO
              <br data-id="element-245" />
              FÍSICA + QUÍMICA
            </h3>

            <div className="bg-green-100 text-green-800 font-bold text-center py-2 rounded-lg mb-4" data-id="element-246">
              AHORRÁS $9.000 ARS
            </div>

            <p className="text-xl font-bold text-gray-800 text-center mb-2" data-id="element-247">
              Te llevas el combo completo de las dos materias
            </p>
            <p className="text-gray-600 text-center mb-8 font-medium" data-id="element-248">
              Todo listo y armado
            </p>

            <div className="mt-auto text-center" data-id="element-249">
              <div className="text-gray-400 text-2xl line-through font-bold mb-1" data-id="element-250">
                $39.980
              </div>
              <div className="text-5xl font-black text-brand-orange mb-8" data-id="element-251">
                $30.980 ARS
              </div>
              <CTAButton text="→ SÍ, QUIERO EL PACK COMPLETO" href="https://checkout.guiadigital360.online/cart/44770181808197:1" isLink={true} className="text-xl py-4" data-id="element-252" />
            </div>
          </div>

          {/* Card 3: Avanzado */}
          <div className="bg-white rounded-3xl p-8 shadow-lg border border-gray-200 flex flex-col h-full" data-id="element-253">
            <div className="text-5xl mb-4" data-id="element-254">📗</div>
            <h3 className="text-2xl font-black text-brand-dark mb-2" data-id="element-255">
              PACK AVANZADO
            </h3>
            <p className="text-xl font-bold text-gray-700 mb-2" data-id="element-256">
              Todo el Pack Iniciación + Cuadernillos 3, 4 y 5
            </p>
            <p className="text-gray-600 mb-2" data-id="element-257">1° a 5° año completo + bonos</p>
            <p className="text-gray-500 text-sm mb-2" data-id="element-258">
              Inorgánica + Orgánica + Ambiente
            </p>
            <p className="text-gray-500 text-sm mb-2" data-id="element-259">
              ✅ Cuadernillos adaptados al diseño curricular de la prov. de Bs.
              As.
            </p>
            <p className="text-gray-500 text-sm mb-8" data-id="element-260">
              ✅ Acceso a actualizaciones del Drive
            </p>

            <div className="mt-auto" data-id="element-261">
              <div className="text-gray-400 text-xl line-through font-bold mb-1" data-id="element-262">
                $39.900
              </div>
              <div className="text-4xl font-black text-brand-orange mb-8" data-id="element-263">
                $24.990 ARS
              </div>
              <CTAButton text="→ QUIERO PACK AVANZADO" href="https://checkout.guiadigital360.online/cart/44552070725701:1" isLink={true} className="text-lg py-3" data-id="element-264" />
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center items-center gap-6 md:gap-12 text-sm md:text-base text-gray-600 font-bold bg-white py-6 px-4 rounded-2xl shadow-sm border border-gray-100" data-id="element-265">
          <span className="flex items-center gap-2" data-id="element-266">
            <LockIcon className="w-6 h-6 text-gray-500" data-id="element-267" /> Pago seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-268">
            <ZapIcon className="w-6 h-6 text-yellow-500" data-id="element-269" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-270">
            <ShieldCheckIcon className="w-6 h-6 text-brand-green" data-id="element-271" /> Garantía 7
            días
          </span>
          <span className="flex items-center gap-2" data-id="element-272">
            <CreditCardIcon className="w-6 h-6 text-blue-500" data-id="element-273" /> Mercado Pago ·
            Tarjeta · Transferencia
          </span>
        </div>
      </div>
    </section>;
}